// /**
// * Checks browser is running on a native mobile device
// */
export const isDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  return (
    /windows phone/i.test(userAgent) ||
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
  );
};

// /**
// * Checks iOS user agent
// */
export const iOS = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

// /**
// * Returns if media query matches mobile
// */
export const isMobile = () => {
  return window.matchMedia('(max-width: 599px)').matches;
};

// /**
// * Returns if media query matches tabletLandscape
// */
export const isTabletLandscape = () => {
  return window.matchMedia('(max-width: 1023px)').matches;
};

// /**
// * Returns the browser's scrollbar width
// */
export const getScrollbarWidth = () => {
  return window.innerWidth - document.documentElement.clientWidth;
};

// /**
// * Checks if an element is focusable
// *
// * @param {Object} el - HTML element you want to check if it's focusable
// */
export const isFocusable = el => {
  if (
    el.tabIndex > 0 ||
    (el.tabIndex === 0 && el.getAttribute('tabIndex') !== null)
  ) {
    return true;
  }

  if (el.disabled) {
    return false;
  }

  /* eslint-disable indent */
  switch (el.nodeName) {
    case 'A':
      return !!el.href && el.rel !== 'ignore';
    case 'INPUT':
      return el.type !== 'hidden' && el.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
  /* eslint-enable indent */
};

// /**
// * Create react module
// */
export const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { render } = require('react-dom');

  nodeList.forEach(node => render(<Component {...node.dataset} />, node));
};

// /**
// * FOCUSABLE ELEMENTS
// */
export const focusableElements = [
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])',
  'a[href]',
  'area[href]',
  'button:not([disabled]):not([aria-hidden])',
  'embed',
  'iframe',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'object',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])'
];

// /**
// * Class names for React
// */
export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// * Check if an element is outside the viewport
// */
export const isOutOfViewport = elem => {
  // Get element's bounding
  const bounding = elem.getBoundingClientRect();

  // Check if it's out of the viewport on each side
  const out = {};
  out.top = bounding.top < 0;
  out.left = bounding.left < 0;
  out.bottom =
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight);
  out.right =
    bounding.right >
    (window.innerWidth || document.documentElement.clientWidth);
  out.any = out.top || out.left || out.bottom || out.right;
  out.all = out.top && out.left && out.bottom && out.right;

  return out;
};

export const sameOrigin = (uri1, uri2 = false) => {
  if (uri1[0] === '/') return true;
  if (uri1[0] === '/' && uri2[0] === '/') return true;
  if (!uri2) uri2 = window.location.href;

  uri1 = new URL(uri1);
  uri2 = new URL(uri2);

  const host1 = uri1.hostname.split('www.')[1];
  const host2 = uri2.hostname.split('www.')[2];

  if (host1 !== host2) return false;
  if (uri1.port !== uri2.port) return false;

  return true;
}

export const updateUrlParameter = (url, param, value) => {
  const pattern = new RegExp(`(${param}=).*?(&|$)`);
  let newUrl = url;
  const newValue = encodeURIComponent(value);

  if (url.search(pattern) >= 0) {
    newUrl = url.replace(pattern, `$1${newValue}$2`);
  } else {
    newUrl = `${newUrl}${
      newUrl.includes('?') ? '&' : '?'
    }${param}=${newValue}`;
  }
  return newUrl;
}
